// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab_2QwlC","tab--selected":"Tab_tab--selected_14q4s","tab__close":"Tab_tab__close_hI9-A","tab__text":"Tab_tab__text_rPU4-"};